export const GOOGLE_API_KEY = 'AIzaSyBAx0QYPkpFOfAm13ijLXTrFuuLBDaAuqc';

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

let days = Array.from(new Array(31), (x,i) => i + 1)
export const DAYS = days;


function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++ ) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const CHART_COLORS = Array.from(new Array(31), (x,i) => getRandomColor());



// WEBPACK FOOTER //
// ./src/logic/constants.js